import React, { Component } from "react";
import { Button, Collapse, Col, Form, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ORFButton } from "../../../common/forms/order-request-form.component";
import { requestDetailsActions } from "../../../../store/external/request-reducer/request-details.reducer";
import { requestLogActions } from "../../../../store/external/request-reducer/request-log.reducer";
import { USER_ROLES_ID as userRoles } from "../../../../utils/constant.utils";
import { ORDER_AUDIT_VERBIAGE, REQUEST_SUB_LINKS as RequestTable } from "../../../../constants/external-constants";
import Translation from "../../../common/translation/translation.component";
import './order-details-comment.component.css';
import Icons from "../../../icon";
import { CONFIRMATION_VALUE } from "../../../../utils/constant.utils";
import { ConfirmationNotificationModal } from "../../../../components/common/modal/confirmation-modal.component";
import { convertToFormatDate } from "../../../../utils/helpers.utils";

class RequestCommentSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showComment: false,
            commentID: 0,
            showModal: false,
            comments: [],
            enableSubmitBtn: true,
            commentData: "",
            commentIndex: null
        }
        this.handleRejectionClick = this.handleRejectionClick.bind(this);
    }

    componentDidMount() {
        this.props.resetCommentData();
    }

    renderByCommentsDates = (comments) => {

        if (comments === undefined || comments === null)
            return;

        var commentsCount = comments.length;

        return Object.values(comments).map((item, index) => {
            if (item.CommentsModels.length > 0) {
                return (
                    <div key={item.CreatedDate + index}>
                        <h1 className="comment-section-date-label">{item.CreatedDate}</h1>
                        {
                            this.renderCommentContent(item.CommentsModels, (commentsCount === (index + 1)))
                        }
                    </div>
                )
            }
        })
    }

    handleDelete(commentID) {
        this.setState({
            commentID: commentID,
            showModal: true,
            modalMessage: "Are you sure you want to delete?"
        });

    }


    handleModal(okCancel) {
        this.setState({
            showModal: false,
        });
        if (CONFIRMATION_VALUE.Ok === okCancel) {
            this.props.deleteCommentAction(this.state.commentID);
        }

    }

    addComment() {
        this.setState({ showComment: !this.setState.showComment });
    }

    closeComment() {
        this.setState({ showComment: false });
    }

    displayComment = (item) => {
        var yearDayMonth = (item.State === false && item.DateUpdated) ? convertToFormatDate(item.DateUpdated, "MMMM DD, YYYY") : "";
        var dateUpdated = (item.State === false && item.DateUpdated) ? convertToFormatDate(item.DateUpdated, "hh:mm A") : "";
        return item.State === false ? ORDER_AUDIT_VERBIAGE.deleteCommentOrder.replace("{yearDayMonth}", yearDayMonth).replace("{time}", dateUpdated) : item.Comment;
    }

    renderCommentContent = (comments, isLastComment) => {
        var commentCount = comments && comments.length;
        return Object.values(comments).map((item, index) => {
            return (
                <div key={index}>
                    {
                        isLastComment && commentCount === index + 1 && item.IsApproved ?
                            this.renderLastApprovedComment(item, index)
                            :
                            item.IsOwnComment ?
                                (
                                    <div key={index}>
                                        <h2 className="comment-name-label">{item.CommentedBy}</h2>
                                        <div 
                                            className="comment-button-container three-col"
                                            onMouseEnter={() => this.setState({ commentIndex: item.CommentId
                                            })}
                                            onMouseLeave={() => this.setState({ commentIndex: null })}
                                        >
                                            <Button className="approval-button" variant="outline-secondary">
                                                {this.displayComment(item)}
                                            </Button>{" "}
                                            {/* {item.State == true || item.State == null ? (  */}
                                        
                                            <Icons
                                                customClassName="icon-trash"
                                                name="trash-can"
                                                size="20px"
                                                containerClass={`${this.state.commentIndex === item.CommentId && item.State ? "icon-circle-plus-container" : "hide-icon"}`}
                                                onClick={() => this.handleDelete(item.CommentId)}
                                            />

                                            <h3 className="comment-time-label">{item.CreatedTime}</h3>
                                        </div>
                                    </div>
                                )
                                :
                                (
                                    <div key={index}>
                                        <h2 className="comment-name-label">{item.CommentedBy}</h2>
                                        <div className="comment-button-container three-col">
                                            <Button className="approval-button" variant="outline-secondary">
                                                {this.displayComment(item)}
                                            </Button>{" "}
                                            <h3 className="comment-time-label">{item.CreatedTime}</h3>
                                        </div>
                                    </div>
                                )
                    }
                   

                    {/* { WILL NOT REMOVE THIS SECTION, AS IT CONTAINS LOGIC THAT MAY BE NEEDED SOON.
                        isLastComment && (comments.length == index + 1) &&
                        <div>
                            {
                                item.IsAddComment ?
                                    item.IsOwnComment ?
                                        <span className="comment-response-button" onClick={this.addComment.bind(this)}><Translation translationKey="add_comment" /></span> :
                                        <span className="comment-response-button" onClick={this.addComment.bind(this)}><Translation translationKey="respond_to_comment" /></span>
                                    : <span className="comment-response-button" onClick={this.addComment.bind(this)}><Translation translationKey="add_comment" /></span>
                            }
                        </div>
                    } */}
                </div>
            )
        })
    }
    renderLastApprovedComment = (item, index) => {
        var imgTitle = "";
        if (item.FileName != null) {
            imgTitle = item.FileName.substring(item.FileName.indexOf("_") + 1);
        }
        return (
            <div>
                <h2 className="comment-name-label">{item.CommentedBy}</h2>
                <div className="comment-button-container three-col">
                    <Button className="approval-button" variant="outline-secondary">
                        {item.Comment}
                    </Button>{" "}
                    <h3 className="comment-time-label">{item.CreatedTime}</h3>
                </div>
            </div>
        )
    }
    handleRejectionClick = async () => {
        const { requestData, handleRejectionCommentSubmission, fetchRequestDetails, fetchRequestProgress, fetchOrderComments, fetchOwnerApproverDetails, fetchRequestLogItems } = this.props;
        let RoleID = parseInt(sessionStorage.getItem('UserRoleID'), 10);
        var isApprover = (RoleID === userRoles.manager || RoleID === userRoles.lineManager || JSON.parse(sessionStorage.getItem('IsWireLineApprover')));
        var isSuccess = await handleRejectionCommentSubmission(requestData.Order);
        if (isSuccess) {
            fetchOwnerApproverDetails();
            fetchRequestDetails();
            fetchRequestProgress();
            fetchOrderComments();
            fetchRequestLogItems(0, RequestTable.orderRequest.id);
        }
    }

    submitComment = async () => {
        const { submitComment, fetchOrderComments } = this.props;
        var res = await submitComment();

        if (res) {
            this.closeComment();
            fetchOrderComments();
        }
        this.setState({ enableSubmitBtn: true }); // Disable the button after submitting the comment
    }

    handleCommentChange = (e) => {
        const commentValue = e.target.value;
        this.setState({
            commentData: commentValue,
            enableSubmitBtn: commentValue.trim().length === 0 // Enable submit if input has content
        });
    };

    render() {
        const { commentData, setCommentData } = this.props;
        return (
            <div className="comment-section-container">
                 <ConfirmationNotificationModal
                        show={this.state.showModal}
                        customClass="comment-notification-modal modal-text-bold"
                        title={'Delete'}
                        handleModal={this.handleModal.bind(this)}
                        message={this.state.modalMessage} />
                 <Row>
                        <Col xs={12} md={12} lg={12}>
                        <div className="comment-form-border">
                        <Form.Control
                            as="textarea"
                            onChange={(e) => {
                                setCommentData(e);
                                this.handleCommentChange(e); 
                                }}
                            value={commentData}
                            rows={4}
                            maxLength={1000}
                                />
                            <Button
                                //bsStyle="primary"
                                className="comment-submit-btn"
                                disabled={this.state.enableSubmitBtn}
                                onClick={this.submitComment}
                            >
                                <Translation translationKey="submit_button" />
                            </Button>
                        </div>
                        </Col>
                </Row>

                {
                    this.renderByCommentsDates(this.props.comments)
                }

               
            </div>
        );
    }
}

export default connect(
    state => {
        const { requestDetail, requestLog } = state;
        return {
            ...requestDetail
            , ...requestLog
        };
    },
    dispatch =>
        bindActionCreators(
            Object.assign({}, requestDetailsActions, requestLogActions),
            dispatch
        )
)(RequestCommentSection);